import Servico from './Servico'

class ProntuarioServico extends Servico {
  constructor() {
    super('prontuario')
  }
}

export default ProntuarioServico
